import { createSlice } from '@reduxjs/toolkit';

const getInitialSelectedImages = () => {
  try {
    const saved = localStorage.getItem('selectedImages');
    return saved ? JSON.parse(saved) : [];
  } catch {
    return [];
  }
};

const getInitialSelectedImagesLabel = () => {
  try {
    const saved = localStorage.getItem('selectedImagesLabel');
    return saved ? JSON.parse(saved) : [];
  } catch {
    return [];
  }
};

const initialState = {
  selectedImages: getInitialSelectedImages(),
  trainingParams: {
    modelType: '',
    trainingTime: null,
    dataset: '',
    status: 'preparing',
  },
  selectedImageLabel: getInitialSelectedImagesLabel(),
};

const trainingModelReducer = createSlice({
  name: 'trainingModel',
  initialState,
  reducers: {
    setSelectedImages: (state, action) => {
      state.selectedImages = action.payload;
      localStorage.setItem('selectedImages', JSON.stringify(action.payload));
    },
    addSelectedImage: (state, action) => {
      const image = action.payload;
      const existingIndex = state.selectedImages.findIndex((img) => img.id === image.id);
      if (existingIndex === -1) {
        state.selectedImages.push(image);
      }
    },
    removeSelectedImage: (state, action) => {
      const imageId = action.payload;
      state.selectedImages = state.selectedImages.filter((img) => img.id !== imageId);
    },
    updateTrainingParams: (state, action) => {
      state.trainingParams = { ...state.trainingParams, ...action.payload };
    },
    clearSelectedData: (state) => {
      state.selectedImages = [];
      localStorage.setItem('selectedImages', JSON.stringify(state.selectedImages));
      state.trainingParams = initialState.trainingParams;
    },
    prepareTrainingData: (state, action) => {
      const { images } = action.payload;
      localStorage.setItem('selectedImages', JSON.stringify(images));
      state.selectedImages = images || [];
      state.trainingParams.status = 'ready';
    },
    countImageLabelAc: (state, action) => {
      const imagesLabel = action.payload;
      localStorage.setItem('selectedImagesLabel', JSON.stringify(imagesLabel));
      state.selectedImageLabel = imagesLabel || [];
    },
  },
});

export const {
  setSelectedImages,
  addSelectedImage,
  removeSelectedImage,
  updateTrainingParams,
  clearSelectedData,
  prepareTrainingData,
  countImageLabelAc,
} = trainingModelReducer.actions;

export const selectSelectedImages = (state) => state.trainingModel.selectedImages;
export const selectTrainingParams = (state) => state.trainingModel.trainingParams;
export const selectIsTrainingReady = (state) => state.trainingModel.selectedImages.length > 0
  || state.trainingModel.selectedPestIds.length > 0
  || state.trainingModel.selectedDiseasedIds.length > 0;
export const selectedImageLabel = (state) => state.trainingModel.selectedImageLabel;

export default trainingModelReducer.reducer;
